<template>
  <div>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :selection="false"
      label-width="80px"
    />
    <el-dialog
      v-if="brandDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="brandDialog"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      width="50%"
      center
    >
      <div style="width: 90%;margin:0 auto">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
          <el-form-item label="品牌名称" prop="brandName">
            <el-input v-model="ruleForm.brandName" placeholder="请输入品牌名称" />
          </el-form-item>
        </el-form>
      </div>
      <div class="flexJCenter mt-25">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="onSubmit()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: '/station/brand/page',
      columns: [
        {
          label: '品牌名称',
          prop: 'name'
        }, {
          label: '创建时间',
          prop: 'createDate'
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: '修改',
            permission: 'system.electric.pile.brand.management.update',
            handle: resp => {
              this.dialogTitle = '修改品牌'
              this.brandDialog = true
              this.ruleForm.brandName = resp.name
              this.id = resp.id
            }
          }
        ]
      },
      query: [
        {
          label: '品牌名称',
          prop: 'brandName',
          placeholder: '请输入品牌名称'
        },
        {
          label: '创建时间',
          prop: 'createTime',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'system.electric.pile.brand.management.add',
          type: 'primary',
          before: (index, record) => {
            this.dialogTitle = '新增品牌'
            this.ruleForm.brandName = ''
            this.brandDialog = true
          }
        }
      ],
      brandDialog: false,
      // 弹窗的标题
      dialogTitle: '',
      id: '',
      // 新增和修改的表单
      ruleForm: {
        brandName: ''
      },
      rules: {
        brandName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      this.ruleForm.brandName = ''
      this.brandDialog = false
    },
    // 点击保存
    onSubmit() {
      let ruleFormBool = false
      this.$refs['ruleForm'].validate(valid => {
        ruleFormBool = valid
      })
      // 表单校验通过
      if (ruleFormBool) {
        if (this.dialogTitle === '新增品牌') {
          this.$store.dispatch('form/handle', {
            url: '/station/brand',
            data: {
              name: this.ruleForm.brandName
            },
            method: 'put',
            callback: () => {
              this.brandDialog = false
              this.$refs.tableref.queryTable()
            }
          })
        } else if (this.dialogTitle === '修改品牌') {
          this.$store.dispatch('form/handle', {
            url: '/station/brand',
            data: {
              id: this.id,
              name: this.ruleForm.brandName
            },
            method: 'post',
            callback: () => {
              this.brandDialog = false
              this.$refs.tableref.queryTable()
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
  .flexJCenter {
    display: flex;
    justify-content: center;
  }
  .mt-25 {
    margin-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/stationBrand.vue